<template>
  <ul class="navbar-nav">
    <li class="nav-item">
      <router-link to="/" exact class="nav-link" active-class="active">Inicio</router-link>
    </li>
    <!-- VENTAS -->
    <v-guard :permissions="['VENTAS']">
      <li class="nav-item">
        <router-link to="/ventas/index" class="nav-link" active-class="active">Ventas</router-link>
      </li>
    </v-guard>
    <!-- COMPRAS -->
    <v-guard :permissions="['COMPRAS']">
      <li class="nav-item">
        <router-link to="/compras" class="nav-link" active-class="active">Compras</router-link>
      </li>
    </v-guard>
    <!-- ECOMMERCE -->
    <v-guard :permissions="['ECOMMERCE']">
      <li class="nav-item">
        <router-link to="/ecom/list" class="nav-link" active-class="active">Ecommerce</router-link>
      </li>
    </v-guard>
    <!-- INVENTARIO -->
    <v-guard :permissions="['INVENTARIO']">
      <li class="nav-item">
        <router-link to="/inventario/productos" class="nav-link" active-class="active">Inventario</router-link>
      </li>
    </v-guard>
    <!-- CAJAS -->
    <v-guard :permissions="['CAJAS']">
      <li class="nav-item">
        <router-link to="/cajas/index" class="nav-link" active-class="active">Cajas</router-link>
      </li>
    </v-guard>
    <!-- REPORTES -->
    <v-guard :permissions="['REPORTES']">
      <li class="nav-item">
        <router-link to="/reports" class="nav-link" active-class="active">Reportes</router-link>
      </li>
    </v-guard>
  </ul>
</template>

<script>
  export default {
  }
</script>

<style scoped>
.navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.85);
  font-weight: bold;
}

.navbar-nav .nav-link:not(.active):not(.dropdown-toggle) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.navbar-nav .nav-link:hover,
.navbar-nav .nav-link:focus {
  color: #ffffff;
}

.navbar-nav .nav-link.active {
  color: #ffffff;
}
</style>